<template>
  <div class="q-pa-md">
    <q-btn
      v-if="!confirmConditionsOfUse"
      size="sm"
      icon="warning"
      color="red"
      outline
      @click="showNotifCheckbox"
      label="DISCLAIMER"
    />
    <q-btn
      v-else
      size="sm"
      icon="warning"
      color="red"
      outline
      @click="showNotifAlert"
      label="DISCLAIMER"
    />
  </div>
</template>
<script setup lang="ts">
import { useQuasar } from 'quasar'
import { useCalculatorStore } from '../stores/calculator.store'
import { storeToRefs } from "pinia"
import { onMounted } from "vue"
const calculatorStore = useCalculatorStore()
const {
  confirmConditionsOfUse,
  isDarkModeGlobal
} = storeToRefs(calculatorStore)
const VITE_APP_TRACKING_API = import.meta.env.VITE_APP_TRACKING_API

function getAnalyticsPayload() {
  return {
    page: window.location.pathname,
    // referrer: document.referrer,
    timestamp: new Date().toISOString(),
    device: {
      screenResolution: { width: window.screen.width, height: window.screen.height },
      viewportSize: { width: window.innerWidth, height: window.innerHeight },
    },
    platform: {
      os: parseOS(navigator.userAgent),
      deviceType: getDeviceType(window.screen.width)
    },
    event: "page_view"
  }
}

// Helper to parse OS from userAgent
function parseOS(userAgent) {
  if (userAgent.includes("Windows")) return "Windows";
  if (userAgent.includes("Mac")) return "MacOS";
  if (userAgent.includes("Linux")) return "Linux";
  if (/Android/i.test(userAgent)) return "Android";
  if (/iPhone|iPad|iPod/i.test(userAgent)) return "iOS";
  return "Unknown";
}

// Helper to infer device type from screen width
function getDeviceType(width) {
  if (width < 768) return "Mobile";
  if (width < 1024) return "Tablet";
  return "Desktop";
}

async function sendAnalytics(payload) {
  try {
    const response = await fetch(VITE_APP_TRACKING_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      mode: 'cors'
    });

    if (!response.ok) {
      console.error(`Analytics failed: ${response.statusText}`);
    }
  } catch (error) {
    console.error('Analytics error:', error);
  }
}

const logEvent = () => {
  const payload = getAnalyticsPayload();
  payload.event = "page_view"; // Track page views specifically
  sendAnalytics(payload);
};



const $q = useQuasar()

function showNotifCheckbox () {
  const message = `<p>This calculator is solely developed to estimate derived quantities like ultrasound intensity and
 mechanical index, which have consequences for both safety and efficacy of ultrasound protocols. It does not account for
  individual differences in anatomy, and is not intended to, and should not be used to, replace an individualized
   acoustic simulation. The calculator is not intended to be and should not be used as a medical device as defined in
    the Medical Device Regulation (Regulation (EU) 2017/745).</p>
  <p>Use of the calculator is at one’s own risk: the calculator is provided “as is”, without warranty of any kind,
   express or implied, including but not limited to the warranties of merchantability, safety, fitness for a particular
    purpose and non-infringement of any rights. In no event shall the creators, authors or copyright holders be liable
     for any claim, damages or other liability, arising from, out of or in connection with the calculator or the use of
      the calculator or data generated with or with the help of the calculator.
  </p>`

  $q.dialog({
    color: 'primary',
    dark: isDarkModeGlobal.value,
    title: 'Conditions of use',
    message: message,
    options: {
      type: 'checkbox',
      model: [],
      isValid: model => model.includes('confirm'),
      items: [
        {label: 'I have read and agree to the conditions', value: 'confirm', color: 'secondary'},
      ]
    },
    cancel: false,
    persistent: true,
    html: true
  }).onOk(() => {
    confirmConditionsOfUse.value = true
    logEvent();
  })
}

function showNotifAlert () {
  const message = `<p>This calculator is solely developed to estimate derived quantities like ultrasound intensity and
 mechanical index, which have consequences for both safety and efficacy of ultrasound protocols. It does not account for
  individual differences in anatomy, and is not intended to, and should not be used to, replace an individualized
   acoustic simulation. The calculator is not intended to be and should not be used as a medical device as defined in
    the Medical Device Regulation (Regulation (EU) 2017/745).</p>
  <p>Use of the calculator is at one’s own risk: the calculator is provided “as is”, without warranty of any kind,
   express or implied, including but not limited to the warranties of merchantability, safety, fitness for a particular
    purpose and non-infringement of any rights. In no event shall the creators, authors or copyright holders be liable
     for any claim, damages or other liability, arising from, out of or in connection with the calculator or the use of
      the calculator or data generated with or with the help of the calculator.
  </p>`

  $q.dialog({
    title: 'Disclaimer',
    message: message,
    persistent: true,
    html: true,
    color: 'primary',
    dark: isDarkModeGlobal.value
  })
}

onMounted(() => {
  if (!confirmConditionsOfUse.value) {
    showNotifCheckbox()
  }
})
</script>
